import { fragmentDocumentReferenceWithBasics } from '@ctw/shared/api/fqs/queries/documents';
import type { SearchConnection } from '@ctw/shared/types/graphql/__generated__/graphql';
import { gql } from 'graphql-request';

export interface SearchGraphqlResponse {
  Search: SearchConnection;
}

export const searchQuery = gql`
  ${fragmentDocumentReferenceWithBasics}  

  query Search(
    $upid: ID! 
    $term: String!
    $first: Int = 500
    $after: String = ""
) {
  Search(upid: $upid, query: $term, first: $first, after: $after) {
    edges {
      node {
        id
        resourceType
        resource {
          ... on DocumentReference {
            ...DocumentWithBasics
          }
        }
        score
        context {
          text
          term
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
`;
